export default "__VITE_ASSET__BJDt4bg8__"